import { render, staticRenderFns } from "./agentIncomeTotal.vue?vue&type=template&id=605300b6&scoped=true"
import script from "./agentIncomeTotal.vue?vue&type=script&lang=js"
export * from "./agentIncomeTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605300b6",
  null
  
)

export default component.exports